// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1816":"04db24fb","3343":"04db24fb","5801":"04db24fb","9939":"561dadf1"}[chunkId] + ".chunk.css";
};